import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAddNewTicketMutation } from "./ticketsApiSlice"

const NewTicketForm = ({ users }) => {

    const [addNewTicket, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewTicketMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState('')
    const [text, setText] = useState('')
    const [userId, setUserId] = useState(users[0].id)

    useEffect(() => {
        if (isSuccess) {
            setTitle('')
            setText('')
            setUserId('')
            navigate('/dash/tickets')
        }
    }, [isSuccess, navigate])

    const onTitleChanged = e => setTitle(e.target.value)
    const onTextChanged = e => setText(e.target.value)
    const onUserIdChanged = e => setUserId(e.target.value)

    const canSave = [title, text, userId].every(Boolean) && !isLoading

    const onSaveTicketClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            await addNewTicket({ user: userId, title, text })
        }
    }

    const options = users.map(user => {
        return (
            <option
                key={user.id}
                value={user.id}
            > {user.username}</option >
        )
    })
    // validate form based on input and give response
    const errClass = isError ? "errmsg" : "offscreen"
    const validTitleClass = !title ? "form__input--incomplete" : ''
    const validTextClass = !text ? "form__input--incomplete" : ''

    const content = (
        <>
           <div className="text-center"> 
           <h2 className="md:text-2xl text-xl font-bold">Add New Ticket </h2>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveTicketClicked}>
     
            {/* +NewTicket Title */}
            <div className=" ml-2">    
             <div>
                <label className="float-left md:float-none ml-2" htmlFor="title">
                    Title:
                </label>
             </div>    
             <div>
                <input
                    className={`rounded-md w-[18rem] md:w-[40rem] text-black pl-1 py-1 ${validTitleClass}`}
                    id="title"
                    name="title"
                    type="text"
                    autoComplete="off"
                    value={title}
                    onChange={onTitleChanged}
                />
              </div>  
             </div>

            {/* +NewTicket Text */}
            <div className="ml-2 pt-[1rem]">
            <div>
                <label className="float-left md:float-none ml-2" htmlFor="text">
                    Text:
                </label>
            </div>

            <div className="text-black">   
                <textarea
                    className={`resize-none pl-2 w-[18rem] md:w-[40rem] max-h-[10rem] rounded-md ${validTextClass}`}
                    id="text"
                    name="text"
                    value={text}
                    onChange={onTextChanged}
                />
            </div>    
            </div>

           {/* +NewTicket Assigned */}
            <div className="ml-2 pt-[1rem]">
               <div> 
                <label className="" htmlFor="username">
                    Assigned To:
                </label>
                </div>

                <div className="">
                <select
                    id="username"
                    name="username"
                    className=" text-black w-[15rem] py-1 rounded-md text-center"
                    value={userId}
                    onChange={onUserIdChanged}>
                    {options}
                </select>
            </div>
            </div>
                
                
            {/* +NewTicket Save */}
                    <div className="mt-[9rem]  md:mt-[18rem] ml-[13rem]  md:ml-[68rem]">
                        <button
                            className="bg-blue-500 hover:bg-blue-700 w-[10rem] text-white px-2 py-2 rounded-md"
                            title="Save"
                            disabled={!canSave}
                        >
                            Send
                        </button>
                    </div>
            </form>
            </div>
        </>
    )

    return content
}

export default NewTicketForm